import { useQuery } from '@tanstack/react-query';
import { ordersApi } from '@/services/orders';

export const useOrder = (orderId: string | null) => {
  return useQuery({
    queryKey: ['order', orderId],
    queryFn: () => ordersApi.get(orderId!),
    enabled: !!orderId,
  });
};

export const useOrders = () => {
  return useQuery({
    queryKey: ['orders'],
    queryFn: () => ordersApi.list(),
    refetchOnMount: 'always',
  });
};
